import axios from '@/libs/api.request'

// 列表
export const apiUserlogList = data => {
  return axios.request({
    url: '/userlog/list',
    method: 'post',
    data
  })
}
